import map from 'lodash/map'
import React, { useContext, VFC } from 'react'

import { Crumb } from '@Components/Breadcrumbs/Crumb'
import { ProductContext } from '@Components/Product/Context'
import { StyledBreadcrumbs } from '@Components/Product/Display/styledElements'
import { NavigationEvent } from '@Events/Navigation'
import { MetadataContext } from '@Globals/Metadata'

export const Breadcrumbs: VFC = () => {
  const product = useContext(ProductContext)
  const { page: { breadcrumbs = [] } = {} } = useContext(MetadataContext)

  if (!product) {
    return null
  }

  return (
    <StyledBreadcrumbs>
      {map(breadcrumbs, (crumb, index) => {
        const { title, type = '', url } = crumb
        return (
          <Crumb
            key={`${index}`}
            event={new NavigationEvent({
              attributes: {
                dest_page_type: type,
                dest_page_type_id: '',
                source_id: 'bread_crumb',
              },
              eventName: 'nav_link_click',
            })}
            href={url || '/'}
            name={title || ''}
          />
        )
      })}
    </StyledBreadcrumbs>
  )
}
